import { Status } from '../wire-format.mjs';
export function validationFunctionToVuetifyRule(f) {
    return (value) => {
        const result = f(value);
        if (result.status === Status.ok) {
            return true;
        }
        else {
            return result.msg;
        }
    };
}
//# sourceMappingURL=Validator.js.map